import { TableFilterConfig, TableFilterOption } from '@/components/data-table/filters-v2';
import i18n from '@/core/i18n';
import { getMemberStatusColor, getMemberStatusText } from '@/modules/common';
import { SingleSelectOption } from '@/modules/common/components/molecules/selectors/single-select/single-select';
import { MemberStatus } from '@/modules/team/types/team-member';

import {
  MEMBER_ACCESS_FILTER_KEY_GROUP_IDS,
  MEMBER_ACCESS_FILTER_KEY_SEARCH,
  MEMBER_ACCESS_FILTER_KEY_STATUSES,
} from './member-access-filter-keys';

interface GetMemberAccessFiltersConfigParams {
  groupOptions: SingleSelectOption[];
  /** Locks the status filter (invite mode pins it to Basic and prevents changes). */
  isStatusLocked?: boolean;
}

export const getMemberAccessFiltersConfig = ({
  groupOptions,
  isStatusLocked = false,
}: GetMemberAccessFiltersConfigParams): TableFilterConfig[] => [
  {
    type: 'search',
    name: MEMBER_ACCESS_FILTER_KEY_SEARCH,
    label: i18n.t('common:search'),
    placeholder: i18n.t('authenticated.settings:pages.members.searchPlaceholder'),
  },
  {
    type: 'autocomplete',
    name: MEMBER_ACCESS_FILTER_KEY_STATUSES,
    label: i18n.t('authenticated.settings:pages.members.statusFilterLabel'),
    disabled: isStatusLocked,
    options: [
      {
        label: getMemberStatusText(MemberStatus.Active),
        value: MemberStatus.Active,
        color: getMemberStatusColor(MemberStatus.Active),
      },
      {
        label: getMemberStatusText(MemberStatus.Invited),
        value: MemberStatus.Invited,
        color: getMemberStatusColor(MemberStatus.Invited),
      },
      {
        label: getMemberStatusText(MemberStatus.Expired),
        value: MemberStatus.Expired,
        color: getMemberStatusColor(MemberStatus.Expired),
      },
      {
        label: getMemberStatusText(MemberStatus.Basic),
        value: MemberStatus.Basic,
        color: getMemberStatusColor(MemberStatus.Basic),
      },
      {
        label: getMemberStatusText(MemberStatus.Placeholder),
        value: MemberStatus.Placeholder,
        color: getMemberStatusColor(MemberStatus.Placeholder),
      },
      {
        label: getMemberStatusText(MemberStatus.Archived),
        value: MemberStatus.Archived,
        color: getMemberStatusColor(MemberStatus.Archived),
      },
    ],
  },
  {
    type: 'autocomplete',
    name: MEMBER_ACCESS_FILTER_KEY_GROUP_IDS,
    label: i18n.t('authenticated.settings:pages.members.groupFilterLabel'),
    withSearch: true,
    options: groupOptions as TableFilterOption[],
  },
];
